export class BestFrame {
    id!: string;
    status!: boolean;
    evaluation!: number;
    facesFound!: Array<string>;
    message!: string;
    processTime!: number;
    bestFrame!: string;
}
